//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class EsraWeldingAPIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getUserAppRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Authorization/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAppRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAppRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserAppRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWeldingRevisionApprovers(): Observable<ICmidUser[]> {
        let url_ = this.baseUrl + "/api/Authorization/weldingapprovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeldingRevisionApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeldingRevisionApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICmidUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICmidUser[]>;
        }));
    }

    protected processGetWeldingRevisionApprovers(response: HttpResponseBase): Observable<ICmidUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICmidUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentalIndicatorData(): Observable<EnvironmentIndicatorViewModel> {
        let url_ = this.baseUrl + "/api/Indicator/getEnvironmentalIndicatorData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironmentalIndicatorData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironmentalIndicatorData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnvironmentIndicatorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnvironmentIndicatorViewModel>;
        }));
    }

    protected processGetEnvironmentalIndicatorData(response: HttpResponseBase): Observable<EnvironmentIndicatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentIndicatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWeldingDocument(fileName: string, documentStatus?: DocumentStatus | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/WeldingDocument/{fileName}?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (documentStatus === null)
            throw new Error("The parameter 'documentStatus' cannot be null.");
        else if (documentStatus !== undefined)
            url_ += "documentStatus=" + encodeURIComponent("" + documentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeldingDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeldingDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetWeldingDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : _responseText;
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWeldingFilters(): Observable<WeldingSearchFilterViewModel[]> {
        let url_ = this.baseUrl + "/api/WeldingFilters/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeldingFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeldingFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingSearchFilterViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingSearchFilterViewModel[]>;
        }));
    }

    protected processGetWeldingFilters(response: HttpResponseBase): Observable<WeldingSearchFilterViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeldingSearchFilterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLatestPublishedVersionOfWeldingProcedure(filename: string): Observable<WeldingProcedureViewModel> {
        let url_ = this.baseUrl + "/api/WeldingProcedure/latestpublished/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPublishedVersionOfWeldingProcedure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPublishedVersionOfWeldingProcedure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingProcedureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingProcedureViewModel>;
        }));
    }

    protected processGetLatestPublishedVersionOfWeldingProcedure(response: HttpResponseBase): Observable<WeldingProcedureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingProcedureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWpsInRevision(id: string, body?: WeldingProcedureViewModel | undefined): Observable<WeldingProcedureViewModel> {
        let url_ = this.baseUrl + "/api/WeldingProcedure/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWpsInRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWpsInRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingProcedureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingProcedureViewModel>;
        }));
    }

    protected processUpdateWpsInRevision(response: HttpResponseBase): Observable<WeldingProcedureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingProcedureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllPublishedWpsNames(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/WeldingProcedure/published";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublishedWpsNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublishedWpsNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllPublishedWpsNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJointDesignsOptions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/WeldingProcedure/jointdesigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJointDesignsOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJointDesignsOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetJointDesignsOptions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRevisions(): Observable<WeldingRevisionViewModel[]> {
        let url_ = this.baseUrl + "/api/WeldingRevision/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel[]>;
        }));
    }

    protected processGetAllRevisions(response: HttpResponseBase): Observable<WeldingRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeldingRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRevisionById(id: number): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processGetRevisionById(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRevision(id: string, body?: WeldingRevisionViewModel | undefined): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processUpdateRevision(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteRevision(id: number): Observable<WeldingRevision> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevision>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevision>;
        }));
    }

    protected processDeleteRevision(response: HttpResponseBase): Observable<WeldingRevision> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevision.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRevision(fileName: string, body?: WeldingRevision | undefined): Observable<WeldingRevision> {
        let url_ = this.baseUrl + "/api/WeldingRevision/create/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevision>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevision>;
        }));
    }

    protected processCreateRevision(response: HttpResponseBase): Observable<WeldingRevision> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevision.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archiveRevision(body?: WeldingRevision | undefined): Observable<WeldingRevision> {
        let url_ = this.baseUrl + "/api/WeldingRevision/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevision>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevision>;
        }));
    }

    protected processArchiveRevision(response: HttpResponseBase): Observable<WeldingRevision> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevision.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    addApproval(id: number, oid: string): Observable<RevisionApprovalViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/approver/{oid}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel>;
        }));
    }

    protected processAddApproval(response: HttpResponseBase): Observable<RevisionApprovalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RevisionApprovalViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeApproval(id: number, oid: string): Observable<RevisionApprovalViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/approver/{oid}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel>;
        }));
    }

    protected processRemoveApproval(response: HttpResponseBase): Observable<RevisionApprovalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionApprovalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateApprovers(id: number, body?: string[] | undefined): Observable<RevisionApprovalViewModel[]> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/UpdateApprovers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApprovers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionApprovalViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionApprovalViewModel[]>;
        }));
    }

    protected processUpdateApprovers(response: HttpResponseBase): Observable<RevisionApprovalViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevisionApprovalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addComment(revisionId: number, body?: RevisionCommentViewModel | undefined): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{revisionId}/comment";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processAddComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateComment(revisionId: number, body?: RevisionCommentViewModel | undefined): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{revisionId}/comment";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processUpdateComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addReply(revisionId: number, commentId: number, body?: RevisionCommentViewModel | undefined): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{revisionId}/comment/{commentId}/reply";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processAddReply(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteComment(id: number, commentId: number): Observable<RevisionCommentViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/comment/{commentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionCommentViewModel>;
        }));
    }

    protected processDeleteComment(response: HttpResponseBase): Observable<RevisionCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    setWeldingProcedureToBeArchived(revisionId: number, name: string): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{revisionId}/weldingprocedure/{name}/archive";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetWeldingProcedureToBeArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetWeldingProcedureToBeArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processSetWeldingProcedureToBeArchived(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WeldingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Created
     */
    addWPSToRevision(id: number, file?: FileParameter | undefined): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/addWPS";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWPSToRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWPSToRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processAddWPSToRevision(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WeldingRevisionViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    deleteWPSFromRevision(id: number, filename: string): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/deleteWPS/{filename}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWPSFromRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWPSFromRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processDeleteWPSFromRevision(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WeldingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    sendRevisionForApproval(id: number): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/sendtoapprovers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRevisionForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRevisionForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processSendRevisionForApproval(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WeldingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    approveRevision(revisionId: number, oid: string): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{revisionId}/approve/{oid}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (oid === undefined || oid === null)
            throw new Error("The parameter 'oid' must be defined.");
        url_ = url_.replace("{oid}", encodeURIComponent("" + oid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processApproveRevision(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WeldingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    rejectRevision(id: number): Observable<WeldingRevisionViewModel> {
        let url_ = this.baseUrl + "/api/WeldingRevision/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevisionViewModel>;
        }));
    }

    protected processRejectRevision(response: HttpResponseBase): Observable<WeldingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WeldingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActiveRevisionWithFile(filename: string): Observable<WeldingRevision> {
        let url_ = this.baseUrl + "/api/WeldingRevision/activerevisions/{filename}";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveRevisionWithFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveRevisionWithFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingRevision>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingRevision>;
        }));
    }

    protected processGetActiveRevisionWithFile(response: HttpResponseBase): Observable<WeldingRevision> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeldingRevision.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchWeldingProcedures(body?: SearchRequest | undefined): Observable<SearchResponse_1OfWeldingProcedureViewModel> {
        let url_ = this.baseUrl + "/api/WeldingSearch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWeldingProcedures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWeldingProcedures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfWeldingProcedureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfWeldingProcedureViewModel>;
        }));
    }

    protected processSearchWeldingProcedures(response: HttpResponseBase): Observable<SearchResponse_1OfWeldingProcedureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfWeldingProcedureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyWorkspace(): Observable<WeldingProcedureViewModel[]> {
        let url_ = this.baseUrl + "/api/WeldingWorkspace/myworkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeldingProcedureViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeldingProcedureViewModel[]>;
        }));
    }

    protected processGetMyWorkspace(response: HttpResponseBase): Observable<WeldingProcedureViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeldingProcedureViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weldingProcedureId (optional) 
     * @return Created
     */
    addWeldingProcedureToWorkspace(weldingProcedureId?: string | undefined): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/WeldingWorkspace/weldingProcedure?";
        if (weldingProcedureId === null)
            throw new Error("The parameter 'weldingProcedureId' cannot be null.");
        else if (weldingProcedureId !== undefined)
            url_ += "weldingProcedureId=" + encodeURIComponent("" + weldingProcedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWeldingProcedureToWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWeldingProcedureToWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processAddWeldingProcedureToWorkspace(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkspaceEntryViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weldingProcedureId (optional) 
     * @return Accepted
     */
    removeWeldingProcedureFromWorkspace(weldingProcedureId?: string | undefined): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/WeldingWorkspace/weldingProcedure?";
        if (weldingProcedureId === null)
            throw new Error("The parameter 'weldingProcedureId' cannot be null.");
        else if (weldingProcedureId !== undefined)
            url_ += "weldingProcedureId=" + encodeURIComponent("" + weldingProcedureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveWeldingProcedureFromWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveWeldingProcedureFromWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processRemoveWeldingProcedureFromWorkspace(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkspaceEntryViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weldingProceduresId (optional) 
     * @return Accepted
     */
    removeWeldingProceduresFromWorkspace(weldingProceduresId?: string[] | undefined): Observable<WorkspaceEntryViewModel> {
        let url_ = this.baseUrl + "/api/WeldingWorkspace/weldingProcedures?";
        if (weldingProceduresId === null)
            throw new Error("The parameter 'weldingProceduresId' cannot be null.");
        else if (weldingProceduresId !== undefined)
            weldingProceduresId && weldingProceduresId.forEach(item => { url_ += "weldingProceduresId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveWeldingProceduresFromWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveWeldingProceduresFromWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceEntryViewModel>;
        }));
    }

    protected processRemoveWeldingProceduresFromWorkspace(response: HttpResponseBase): Observable<WorkspaceEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkspaceEntryViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ICmidUser implements IICmidUser {
    objectId?: string | undefined;
    userPrincipalName?: string | undefined;
    provisioningId?: string | undefined;
    logonName?: string | undefined;
    userType?: string | undefined;
    personRelationshipType?: string | undefined;
    email?: string | undefined;
    accountEnabled?: boolean | undefined;
    businessPhones?: string | undefined;
    displayName?: string | undefined;
    preferredName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    jobTitle?: string | undefined;
    mail?: string | undefined;
    mobilePhone?: string | undefined;
    department?: string | undefined;
    companyName?: string | undefined;
    officeLocation?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    preferredLanguage?: string | undefined;
    usageLocation?: string | undefined;
    hrguid?: string | undefined;
    sourcingCompanyId?: string | undefined;
    workerLegalFirstName?: string | undefined;
    workerLegalMiddleName?: string | undefined;
    workerLegalLastName?: string | undefined;
    workerPositionTitle?: string | undefined;
    workerWorkCompanyCode?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    locationId?: string | undefined;
    locationPropertyId?: string | undefined;
    locationFacilityCode?: string | undefined;
    organizationLevel1Code?: string | undefined;
    organizationLevel1Name?: string | undefined;
    organizationLevel2Code?: string | undefined;
    organizationLevel2Name?: string | undefined;
    organizationLevel3Code?: string | undefined;
    organizationLevel3Name?: string | undefined;
    organizationLevel4Code?: string | undefined;
    organizationLevel4Name?: string | undefined;
    organizationLevel5Code?: string | undefined;
    organizationLevel5Name?: string | undefined;
    manager?: ICmidUser;

    constructor(data?: IICmidUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.provisioningId = _data["provisioningId"];
            this.logonName = _data["logonName"];
            this.userType = _data["userType"];
            this.personRelationshipType = _data["personRelationshipType"];
            this.email = _data["email"];
            this.accountEnabled = _data["accountEnabled"];
            this.businessPhones = _data["businessPhones"];
            this.displayName = _data["displayName"];
            this.preferredName = _data["preferredName"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.jobTitle = _data["jobTitle"];
            this.mail = _data["mail"];
            this.mobilePhone = _data["mobilePhone"];
            this.department = _data["department"];
            this.companyName = _data["companyName"];
            this.officeLocation = _data["officeLocation"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.usageLocation = _data["usageLocation"];
            this.hrguid = _data["hrguid"];
            this.sourcingCompanyId = _data["sourcingCompanyId"];
            this.workerLegalFirstName = _data["workerLegalFirstName"];
            this.workerLegalMiddleName = _data["workerLegalMiddleName"];
            this.workerLegalLastName = _data["workerLegalLastName"];
            this.workerPositionTitle = _data["workerPositionTitle"];
            this.workerWorkCompanyCode = _data["workerWorkCompanyCode"];
            this.workerWorkCompanyName = _data["workerWorkCompanyName"];
            this.locationId = _data["locationId"];
            this.locationPropertyId = _data["locationPropertyId"];
            this.locationFacilityCode = _data["locationFacilityCode"];
            this.organizationLevel1Code = _data["organizationLevel1Code"];
            this.organizationLevel1Name = _data["organizationLevel1Name"];
            this.organizationLevel2Code = _data["organizationLevel2Code"];
            this.organizationLevel2Name = _data["organizationLevel2Name"];
            this.organizationLevel3Code = _data["organizationLevel3Code"];
            this.organizationLevel3Name = _data["organizationLevel3Name"];
            this.organizationLevel4Code = _data["organizationLevel4Code"];
            this.organizationLevel4Name = _data["organizationLevel4Name"];
            this.organizationLevel5Code = _data["organizationLevel5Code"];
            this.organizationLevel5Name = _data["organizationLevel5Name"];
            this.manager = _data["manager"] ? ICmidUser.fromJS(_data["manager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICmidUser {
        data = typeof data === 'object' ? data : {};
        let result = new ICmidUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["userPrincipalName"] = this.userPrincipalName;
        data["provisioningId"] = this.provisioningId;
        data["logonName"] = this.logonName;
        data["userType"] = this.userType;
        data["personRelationshipType"] = this.personRelationshipType;
        data["email"] = this.email;
        data["accountEnabled"] = this.accountEnabled;
        data["businessPhones"] = this.businessPhones;
        data["displayName"] = this.displayName;
        data["preferredName"] = this.preferredName;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["jobTitle"] = this.jobTitle;
        data["mail"] = this.mail;
        data["mobilePhone"] = this.mobilePhone;
        data["department"] = this.department;
        data["companyName"] = this.companyName;
        data["officeLocation"] = this.officeLocation;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["preferredLanguage"] = this.preferredLanguage;
        data["usageLocation"] = this.usageLocation;
        data["hrguid"] = this.hrguid;
        data["sourcingCompanyId"] = this.sourcingCompanyId;
        data["workerLegalFirstName"] = this.workerLegalFirstName;
        data["workerLegalMiddleName"] = this.workerLegalMiddleName;
        data["workerLegalLastName"] = this.workerLegalLastName;
        data["workerPositionTitle"] = this.workerPositionTitle;
        data["workerWorkCompanyCode"] = this.workerWorkCompanyCode;
        data["workerWorkCompanyName"] = this.workerWorkCompanyName;
        data["locationId"] = this.locationId;
        data["locationPropertyId"] = this.locationPropertyId;
        data["locationFacilityCode"] = this.locationFacilityCode;
        data["organizationLevel1Code"] = this.organizationLevel1Code;
        data["organizationLevel1Name"] = this.organizationLevel1Name;
        data["organizationLevel2Code"] = this.organizationLevel2Code;
        data["organizationLevel2Name"] = this.organizationLevel2Name;
        data["organizationLevel3Code"] = this.organizationLevel3Code;
        data["organizationLevel3Name"] = this.organizationLevel3Name;
        data["organizationLevel4Code"] = this.organizationLevel4Code;
        data["organizationLevel4Name"] = this.organizationLevel4Name;
        data["organizationLevel5Code"] = this.organizationLevel5Code;
        data["organizationLevel5Name"] = this.organizationLevel5Name;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICmidUser {
    objectId?: string | undefined;
    userPrincipalName?: string | undefined;
    provisioningId?: string | undefined;
    logonName?: string | undefined;
    userType?: string | undefined;
    personRelationshipType?: string | undefined;
    email?: string | undefined;
    accountEnabled?: boolean | undefined;
    businessPhones?: string | undefined;
    displayName?: string | undefined;
    preferredName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    jobTitle?: string | undefined;
    mail?: string | undefined;
    mobilePhone?: string | undefined;
    department?: string | undefined;
    companyName?: string | undefined;
    officeLocation?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    preferredLanguage?: string | undefined;
    usageLocation?: string | undefined;
    hrguid?: string | undefined;
    sourcingCompanyId?: string | undefined;
    workerLegalFirstName?: string | undefined;
    workerLegalMiddleName?: string | undefined;
    workerLegalLastName?: string | undefined;
    workerPositionTitle?: string | undefined;
    workerWorkCompanyCode?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    locationId?: string | undefined;
    locationPropertyId?: string | undefined;
    locationFacilityCode?: string | undefined;
    organizationLevel1Code?: string | undefined;
    organizationLevel1Name?: string | undefined;
    organizationLevel2Code?: string | undefined;
    organizationLevel2Name?: string | undefined;
    organizationLevel3Code?: string | undefined;
    organizationLevel3Name?: string | undefined;
    organizationLevel4Code?: string | undefined;
    organizationLevel4Name?: string | undefined;
    organizationLevel5Code?: string | undefined;
    organizationLevel5Name?: string | undefined;
    manager?: ICmidUser;
}

export class EsraSearchFilterModel implements IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;

    constructor(data?: IEsraSearchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): EsraSearchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EsraSearchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }
}

export interface IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export enum FilterType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class FilterableProperty implements IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;

    constructor(data?: IFilterableProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.propertyName = _data["propertyName"];
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(item);
            }
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterableProperty {
        data = typeof data === 'object' ? data : {};
        let result = new FilterableProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["propertyName"] = this.propertyName;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item);
        }
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;
}

export class SearchRequest implements ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.mainSearch = _data["mainSearch"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterableProperty.fromJS(item));
            }
            this.orderBy = _data["orderBy"];
            this.highlightMatches = _data["highlightMatches"];
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["mainSearch"] = this.mainSearch;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["orderBy"] = this.orderBy;
        data["highlightMatches"] = this.highlightMatches;
        return data;
    }
}

export interface ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;
}

export class SearchResponse_1OfWeldingProcedureViewModel implements ISearchResponse_1OfWeldingProcedureViewModel {
    totalResults?: number;
    results?: WeldingProcedureViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfWeldingProcedureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WeldingProcedureViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfWeldingProcedureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfWeldingProcedureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfWeldingProcedureViewModel {
    totalResults?: number;
    results?: WeldingProcedureViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export enum RevisionStatus {
    DRAFT = 0,
    REVIEW = 1,
    APPROVAL = 2,
    PUBLISHED = 3,
    REVIEW_WITH_REJECTIONS = 10,
    REVIEW_WITH_PENDING_COMMENTS = 11,
    APPROVAL_WITH_PENDING_COMMENTS = 12,
    RETIRED = 100,
    REJECTED = 101,
}

export class EnvironmentIndicatorViewModel implements IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;

    constructor(data?: IEnvironmentIndicatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureSearchPath = _data["azureSearchPath"];
            this.version = _data["version"];
            this.versionInfo = _data["versionInfo"] ? VersionInfo.fromJS(_data["versionInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnvironmentIndicatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentIndicatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureSearchPath"] = this.azureSearchPath;
        data["version"] = this.version;
        data["versionInfo"] = this.versionInfo ? this.versionInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;
}

export class VersionInfo implements IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;

    constructor(data?: IVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.commitHash = _data["commitHash"];
            this.commitDate = _data["commitDate"];
            this.assemblyName = _data["assemblyName"];
        }
    }

    static fromJS(data: any): VersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["commitHash"] = this.commitHash;
        data["commitDate"] = this.commitDate;
        data["assemblyName"] = this.assemblyName;
        return data;
    }
}

export interface IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;
}

export class JointDesign implements IJointDesign {
    id?: string;
    name?: string | undefined;
    order?: number;
    weldingProcedures?: WeldingProcedure[] | undefined;

    constructor(data?: IJointDesign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            if (Array.isArray(_data["weldingProcedures"])) {
                this.weldingProcedures = [] as any;
                for (let item of _data["weldingProcedures"])
                    this.weldingProcedures!.push(WeldingProcedure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JointDesign {
        data = typeof data === 'object' ? data : {};
        let result = new JointDesign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        if (Array.isArray(this.weldingProcedures)) {
            data["weldingProcedures"] = [];
            for (let item of this.weldingProcedures)
                data["weldingProcedures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJointDesign {
    id?: string;
    name?: string | undefined;
    order?: number;
    weldingProcedures?: WeldingProcedure[] | undefined;
}

export class RevisionApproval implements IRevisionApproval {
    id?: number;
    weldingRevisionId?: number;
    weldingRevision?: WeldingRevision;
    approverOid!: string;
    status?: RevisionApprovalStatus;
    updatedAt?: Date;

    constructor(data?: IRevisionApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weldingRevisionId = _data["weldingRevisionId"];
            this.weldingRevision = _data["weldingRevision"] ? WeldingRevision.fromJS(_data["weldingRevision"]) : <any>undefined;
            this.approverOid = _data["approverOid"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RevisionApproval {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weldingRevisionId"] = this.weldingRevisionId;
        data["weldingRevision"] = this.weldingRevision ? this.weldingRevision.toJSON() : <any>undefined;
        data["approverOid"] = this.approverOid;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRevisionApproval {
    id?: number;
    weldingRevisionId?: number;
    weldingRevision?: WeldingRevision;
    approverOid: string;
    status?: RevisionApprovalStatus;
    updatedAt?: Date;
}

export enum RevisionApprovalStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RevisionComment implements IRevisionComment {
    id?: number;
    comment?: string | undefined;
    weldingRevisionId?: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    replies?: RevisionComment[] | undefined;

    constructor(data?: IRevisionComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.weldingRevisionId = _data["weldingRevisionId"];
            this.createdByOid = _data["createdByOid"];
            this.updatedByOid = _data["updatedByOid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.parentCommentId = _data["parentCommentId"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(RevisionComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionComment {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["weldingRevisionId"] = this.weldingRevisionId;
        data["createdByOid"] = this.createdByOid;
        data["updatedByOid"] = this.updatedByOid;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["parentCommentId"] = this.parentCommentId;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevisionComment {
    id?: number;
    comment?: string | undefined;
    weldingRevisionId?: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    replies?: RevisionComment[] | undefined;
}

export enum RevisionCommentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class WeldingProcedure implements IWeldingProcedure {
    id?: string;
    wps?: string | undefined;
    filename?: string | undefined;
    application?: string | undefined;
    baseMetalPNo1?: string | undefined;
    baseMetalPNo2?: string | undefined;
    classification1?: string | undefined;
    preheatFahrenheit?: number | undefined;
    postWeldHeatTreatment?: boolean | undefined;
    shieldcomp?: string | undefined;
    gmaWmode?: string | undefined;
    maxHeatInputKiloJoules?: number | undefined;
    jointDesigns?: JointDesign[] | undefined;
    weldingProcedureProperties?: WeldingProcedureProperty[] | undefined;
    fromRevisionId?: number;
    fromRevision?: WeldingRevision;
    toRevisionId?: number;

    constructor(data?: IWeldingProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wps = _data["wps"];
            this.filename = _data["filename"];
            this.application = _data["application"];
            this.baseMetalPNo1 = _data["baseMetalPNo1"];
            this.baseMetalPNo2 = _data["baseMetalPNo2"];
            this.classification1 = _data["classification1"];
            this.preheatFahrenheit = _data["preheatFahrenheit"];
            this.postWeldHeatTreatment = _data["postWeldHeatTreatment"];
            this.shieldcomp = _data["shieldcomp"];
            this.gmaWmode = _data["gmaWmode"];
            this.maxHeatInputKiloJoules = _data["maxHeatInputKiloJoules"];
            if (Array.isArray(_data["jointDesigns"])) {
                this.jointDesigns = [] as any;
                for (let item of _data["jointDesigns"])
                    this.jointDesigns!.push(JointDesign.fromJS(item));
            }
            if (Array.isArray(_data["weldingProcedureProperties"])) {
                this.weldingProcedureProperties = [] as any;
                for (let item of _data["weldingProcedureProperties"])
                    this.weldingProcedureProperties!.push(WeldingProcedureProperty.fromJS(item));
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? WeldingRevision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
        }
    }

    static fromJS(data: any): WeldingProcedure {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingProcedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wps"] = this.wps;
        data["filename"] = this.filename;
        data["application"] = this.application;
        data["baseMetalPNo1"] = this.baseMetalPNo1;
        data["baseMetalPNo2"] = this.baseMetalPNo2;
        data["classification1"] = this.classification1;
        data["preheatFahrenheit"] = this.preheatFahrenheit;
        data["postWeldHeatTreatment"] = this.postWeldHeatTreatment;
        data["shieldcomp"] = this.shieldcomp;
        data["gmaWmode"] = this.gmaWmode;
        data["maxHeatInputKiloJoules"] = this.maxHeatInputKiloJoules;
        if (Array.isArray(this.jointDesigns)) {
            data["jointDesigns"] = [];
            for (let item of this.jointDesigns)
                data["jointDesigns"].push(item.toJSON());
        }
        if (Array.isArray(this.weldingProcedureProperties)) {
            data["weldingProcedureProperties"] = [];
            for (let item of this.weldingProcedureProperties)
                data["weldingProcedureProperties"].push(item.toJSON());
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        return data;
    }
}

export interface IWeldingProcedure {
    id?: string;
    wps?: string | undefined;
    filename?: string | undefined;
    application?: string | undefined;
    baseMetalPNo1?: string | undefined;
    baseMetalPNo2?: string | undefined;
    classification1?: string | undefined;
    preheatFahrenheit?: number | undefined;
    postWeldHeatTreatment?: boolean | undefined;
    shieldcomp?: string | undefined;
    gmaWmode?: string | undefined;
    maxHeatInputKiloJoules?: number | undefined;
    jointDesigns?: JointDesign[] | undefined;
    weldingProcedureProperties?: WeldingProcedureProperty[] | undefined;
    fromRevisionId?: number;
    fromRevision?: WeldingRevision;
    toRevisionId?: number;
}

export class WeldingProcedureProperty implements IWeldingProcedureProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    weldingProcedureId!: string;
    weldingProcedure?: WeldingProcedure;
    updateAt?: Date;

    constructor(data?: IWeldingProcedureProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.weldingProcedureId = _data["weldingProcedureId"];
            this.weldingProcedure = _data["weldingProcedure"] ? WeldingProcedure.fromJS(_data["weldingProcedure"]) : <any>undefined;
            this.updateAt = _data["updateAt"] ? new Date(_data["updateAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeldingProcedureProperty {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingProcedureProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["weldingProcedureId"] = this.weldingProcedureId;
        data["weldingProcedure"] = this.weldingProcedure ? this.weldingProcedure.toJSON() : <any>undefined;
        data["updateAt"] = this.updateAt ? this.updateAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWeldingProcedureProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    weldingProcedureId: string;
    weldingProcedure?: WeldingProcedure;
    updateAt?: Date;
}

export class WeldingRevision implements IWeldingRevision {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    publishDate?: Date;
    authorOid?: string;
    status?: RevisionStatus;
    approvals?: RevisionApproval[] | undefined;
    comments?: RevisionComment[] | undefined;
    weldingProcedures?: WeldingProcedure[] | undefined;
    weldingRevisionItemArchives?: WeldingRevisionItemArchive[] | undefined;

    constructor(data?: IWeldingRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.authorOid = _data["authorOid"];
            this.status = _data["status"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(RevisionApproval.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(RevisionComment.fromJS(item));
            }
            if (Array.isArray(_data["weldingProcedures"])) {
                this.weldingProcedures = [] as any;
                for (let item of _data["weldingProcedures"])
                    this.weldingProcedures!.push(WeldingProcedure.fromJS(item));
            }
            if (Array.isArray(_data["weldingRevisionItemArchives"])) {
                this.weldingRevisionItemArchives = [] as any;
                for (let item of _data["weldingRevisionItemArchives"])
                    this.weldingRevisionItemArchives!.push(WeldingRevisionItemArchive.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeldingRevision {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["authorOid"] = this.authorOid;
        data["status"] = this.status;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.weldingProcedures)) {
            data["weldingProcedures"] = [];
            for (let item of this.weldingProcedures)
                data["weldingProcedures"].push(item.toJSON());
        }
        if (Array.isArray(this.weldingRevisionItemArchives)) {
            data["weldingRevisionItemArchives"] = [];
            for (let item of this.weldingRevisionItemArchives)
                data["weldingRevisionItemArchives"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeldingRevision {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    publishDate?: Date;
    authorOid?: string;
    status?: RevisionStatus;
    approvals?: RevisionApproval[] | undefined;
    comments?: RevisionComment[] | undefined;
    weldingProcedures?: WeldingProcedure[] | undefined;
    weldingRevisionItemArchives?: WeldingRevisionItemArchive[] | undefined;
}

export class WeldingRevisionItemArchive implements IWeldingRevisionItemArchive {
    itemId?: string;
    weldingRevisionId?: number;
    weldingRevision?: WeldingRevision;

    constructor(data?: IWeldingRevisionItemArchive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.weldingRevisionId = _data["weldingRevisionId"];
            this.weldingRevision = _data["weldingRevision"] ? WeldingRevision.fromJS(_data["weldingRevision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WeldingRevisionItemArchive {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingRevisionItemArchive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["weldingRevisionId"] = this.weldingRevisionId;
        data["weldingRevision"] = this.weldingRevision ? this.weldingRevision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWeldingRevisionItemArchive {
    itemId?: string;
    weldingRevisionId?: number;
    weldingRevision?: WeldingRevision;
}

export enum DocumentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RevisionApprovalViewModel implements IRevisionApprovalViewModel {
    id?: number;
    weldingRevisionId?: number;
    approverOid?: string;
    name?: string | undefined;
    status?: RevisionApprovalStatus;
    updatedAt?: Date;

    constructor(data?: IRevisionApprovalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weldingRevisionId = _data["weldingRevisionId"];
            this.approverOid = _data["approverOid"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RevisionApprovalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionApprovalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weldingRevisionId"] = this.weldingRevisionId;
        data["approverOid"] = this.approverOid;
        data["name"] = this.name;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRevisionApprovalViewModel {
    id?: number;
    weldingRevisionId?: number;
    approverOid?: string;
    name?: string | undefined;
    status?: RevisionApprovalStatus;
    updatedAt?: Date;
}

export class RevisionCommentViewModel implements IRevisionCommentViewModel {
    id?: number;
    comment!: string;
    weldingRevisionId!: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionCommentViewModel[] | undefined;

    constructor(data?: IRevisionCommentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.weldingRevisionId = _data["weldingRevisionId"];
            this.createdByOid = _data["createdByOid"];
            this.updatedByOid = _data["updatedByOid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.parentCommentId = _data["parentCommentId"];
            this.linkedCoatingSystemId = _data["linkedCoatingSystemId"];
            this.linkedCoatingProductId = _data["linkedCoatingProductId"];
            this.linkedCoatingSystemSolutionId = _data["linkedCoatingSystemSolutionId"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(RevisionCommentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionCommentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionCommentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["weldingRevisionId"] = this.weldingRevisionId;
        data["createdByOid"] = this.createdByOid;
        data["updatedByOid"] = this.updatedByOid;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["parentCommentId"] = this.parentCommentId;
        data["linkedCoatingSystemId"] = this.linkedCoatingSystemId;
        data["linkedCoatingProductId"] = this.linkedCoatingProductId;
        data["linkedCoatingSystemSolutionId"] = this.linkedCoatingSystemSolutionId;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevisionCommentViewModel {
    id?: number;
    comment: string;
    weldingRevisionId: number;
    createdByOid?: string;
    updatedByOid?: string;
    createdAt?: Date;
    status?: RevisionCommentStatus;
    updatedAt?: Date;
    parentCommentId?: number | undefined;
    linkedCoatingSystemId?: string | undefined;
    linkedCoatingProductId?: string | undefined;
    linkedCoatingSystemSolutionId?: string | undefined;
    replies?: RevisionCommentViewModel[] | undefined;
}

export class WeldingProcedureViewModel implements IWeldingProcedureViewModel {
    weldingProcedureId?: string | undefined;
    wps?: string | undefined;
    filename?: string | undefined;
    application?: string | undefined;
    baseMetalPNo1?: string | undefined;
    baseMetalPNo2?: string | undefined;
    thicknessMinInch?: string | undefined;
    thicknessMaxInch?: string | undefined;
    classification1?: string | undefined;
    maximumWeldDeposit?: string | undefined;
    preheatFahrenheit?: string | undefined;
    shieldcomp?: string | undefined;
    gmaWmode?: string | undefined;
    maxHeatInputKiloJoules?: string | undefined;
    postWeldHeatTreatment?: boolean;
    impactTemperatureFahrenheit?: string[] | undefined;
    electrodes?: string[] | undefined;
    weldProcess?: string[] | undefined;
    jointDesigns?: string[] | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;

    constructor(data?: IWeldingProcedureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weldingProcedureId = _data["weldingProcedureId"];
            this.wps = _data["wps"];
            this.filename = _data["filename"];
            this.application = _data["application"];
            this.baseMetalPNo1 = _data["baseMetalPNo1"];
            this.baseMetalPNo2 = _data["baseMetalPNo2"];
            this.thicknessMinInch = _data["thicknessMinInch"];
            this.thicknessMaxInch = _data["thicknessMaxInch"];
            this.classification1 = _data["classification1"];
            this.maximumWeldDeposit = _data["maximumWeldDeposit"];
            this.preheatFahrenheit = _data["preheatFahrenheit"];
            this.shieldcomp = _data["shieldcomp"];
            this.gmaWmode = _data["gmaWmode"];
            this.maxHeatInputKiloJoules = _data["maxHeatInputKiloJoules"];
            this.postWeldHeatTreatment = _data["postWeldHeatTreatment"];
            if (Array.isArray(_data["impactTemperatureFahrenheit"])) {
                this.impactTemperatureFahrenheit = [] as any;
                for (let item of _data["impactTemperatureFahrenheit"])
                    this.impactTemperatureFahrenheit!.push(item);
            }
            if (Array.isArray(_data["electrodes"])) {
                this.electrodes = [] as any;
                for (let item of _data["electrodes"])
                    this.electrodes!.push(item);
            }
            if (Array.isArray(_data["weldProcess"])) {
                this.weldProcess = [] as any;
                for (let item of _data["weldProcess"])
                    this.weldProcess!.push(item);
            }
            if (Array.isArray(_data["jointDesigns"])) {
                this.jointDesigns = [] as any;
                for (let item of _data["jointDesigns"])
                    this.jointDesigns!.push(item);
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.toRevisionId = _data["toRevisionId"];
        }
    }

    static fromJS(data: any): WeldingProcedureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingProcedureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weldingProcedureId"] = this.weldingProcedureId;
        data["wps"] = this.wps;
        data["filename"] = this.filename;
        data["application"] = this.application;
        data["baseMetalPNo1"] = this.baseMetalPNo1;
        data["baseMetalPNo2"] = this.baseMetalPNo2;
        data["thicknessMinInch"] = this.thicknessMinInch;
        data["thicknessMaxInch"] = this.thicknessMaxInch;
        data["classification1"] = this.classification1;
        data["maximumWeldDeposit"] = this.maximumWeldDeposit;
        data["preheatFahrenheit"] = this.preheatFahrenheit;
        data["shieldcomp"] = this.shieldcomp;
        data["gmaWmode"] = this.gmaWmode;
        data["maxHeatInputKiloJoules"] = this.maxHeatInputKiloJoules;
        data["postWeldHeatTreatment"] = this.postWeldHeatTreatment;
        if (Array.isArray(this.impactTemperatureFahrenheit)) {
            data["impactTemperatureFahrenheit"] = [];
            for (let item of this.impactTemperatureFahrenheit)
                data["impactTemperatureFahrenheit"].push(item);
        }
        if (Array.isArray(this.electrodes)) {
            data["electrodes"] = [];
            for (let item of this.electrodes)
                data["electrodes"].push(item);
        }
        if (Array.isArray(this.weldProcess)) {
            data["weldProcess"] = [];
            for (let item of this.weldProcess)
                data["weldProcess"].push(item);
        }
        if (Array.isArray(this.jointDesigns)) {
            data["jointDesigns"] = [];
            for (let item of this.jointDesigns)
                data["jointDesigns"].push(item);
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["toRevisionId"] = this.toRevisionId;
        return data;
    }
}

export interface IWeldingProcedureViewModel {
    weldingProcedureId?: string | undefined;
    wps?: string | undefined;
    filename?: string | undefined;
    application?: string | undefined;
    baseMetalPNo1?: string | undefined;
    baseMetalPNo2?: string | undefined;
    thicknessMinInch?: string | undefined;
    thicknessMaxInch?: string | undefined;
    classification1?: string | undefined;
    maximumWeldDeposit?: string | undefined;
    preheatFahrenheit?: string | undefined;
    shieldcomp?: string | undefined;
    gmaWmode?: string | undefined;
    maxHeatInputKiloJoules?: string | undefined;
    postWeldHeatTreatment?: boolean;
    impactTemperatureFahrenheit?: string[] | undefined;
    electrodes?: string[] | undefined;
    weldProcess?: string[] | undefined;
    jointDesigns?: string[] | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;
}

export class WeldingRevisionViewModel implements IWeldingRevisionViewModel {
    id?: number;
    name!: string;
    description!: string;
    publishDate?: Date;
    authorOid?: string;
    status!: RevisionStatus;
    isMajor!: boolean;
    major?: number;
    minor?: number;
    reviewDueDate?: Date | undefined;
    approvals?: RevisionApprovalViewModel[] | undefined;
    comments?: RevisionCommentViewModel[] | undefined;
    itemsToArchive?: string[] | undefined;
    weldingProcedures?: WeldingProcedureViewModel[] | undefined;

    constructor(data?: IWeldingRevisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.authorOid = _data["authorOid"];
            this.status = _data["status"];
            this.isMajor = _data["isMajor"];
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.reviewDueDate = _data["reviewDueDate"] ? new Date(_data["reviewDueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(RevisionApprovalViewModel.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(RevisionCommentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["itemsToArchive"])) {
                this.itemsToArchive = [] as any;
                for (let item of _data["itemsToArchive"])
                    this.itemsToArchive!.push(item);
            }
            if (Array.isArray(_data["weldingProcedures"])) {
                this.weldingProcedures = [] as any;
                for (let item of _data["weldingProcedures"])
                    this.weldingProcedures!.push(WeldingProcedureViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeldingRevisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingRevisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["authorOid"] = this.authorOid;
        data["status"] = this.status;
        data["isMajor"] = this.isMajor;
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["reviewDueDate"] = this.reviewDueDate ? this.reviewDueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.itemsToArchive)) {
            data["itemsToArchive"] = [];
            for (let item of this.itemsToArchive)
                data["itemsToArchive"].push(item);
        }
        if (Array.isArray(this.weldingProcedures)) {
            data["weldingProcedures"] = [];
            for (let item of this.weldingProcedures)
                data["weldingProcedures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeldingRevisionViewModel {
    id?: number;
    name: string;
    description: string;
    publishDate?: Date;
    authorOid?: string;
    status: RevisionStatus;
    isMajor: boolean;
    major?: number;
    minor?: number;
    reviewDueDate?: Date | undefined;
    approvals?: RevisionApprovalViewModel[] | undefined;
    comments?: RevisionCommentViewModel[] | undefined;
    itemsToArchive?: string[] | undefined;
    weldingProcedures?: WeldingProcedureViewModel[] | undefined;
}

export class WeldingSearchFilterViewModel implements IWeldingSearchFilterViewModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    filterTypeDisplayName?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    id?: string;

    constructor(data?: IWeldingSearchFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.filterTypeDisplayName = _data["filterTypeDisplayName"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WeldingSearchFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeldingSearchFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["filterTypeDisplayName"] = this.filterTypeDisplayName;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["id"] = this.id;
        return data;
    }
}

export interface IWeldingSearchFilterViewModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    filterTypeDisplayName?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    id?: string;
}

export class WorkspaceEntryViewModel implements IWorkspaceEntryViewModel {
    id?: string;
    userOid?: string;
    weldingProcedureId?: string;
    weldingProcedure?: WeldingProcedureViewModel;

    constructor(data?: IWorkspaceEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userOid = _data["userOid"];
            this.weldingProcedureId = _data["weldingProcedureId"];
            this.weldingProcedure = _data["weldingProcedure"] ? WeldingProcedureViewModel.fromJS(_data["weldingProcedure"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userOid"] = this.userOid;
        data["weldingProcedureId"] = this.weldingProcedureId;
        data["weldingProcedure"] = this.weldingProcedure ? this.weldingProcedure.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspaceEntryViewModel {
    id?: string;
    userOid?: string;
    weldingProcedureId?: string;
    weldingProcedure?: WeldingProcedureViewModel;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}